
import {products} from "./feature.products.svelte.js";
import {progress} from "../progress/feature.progress.svelte.js";
import * as booking_scenarios_receipt from "../booking/booking.scenarios.update.receipt.svelte.js";
import * as products_select from "./products.scenarios.select.svelte.js";
import * as products_update from "./products.scenarios.update.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil";
import {ENVIRONMENT_DEN_ILP, ENVIRONMENT_DEVARANA, ENVIRONMENT_RIDDERRODE, ENVIRONMENT_SWEETLAKE} from "../../AppConstants";
import AppConfig from "../../AppConfig";
import * as booker_update from "../booker/booker.scenarios.update.svelte.js";
import * as booking_actions from '../booking/actions_booking.svelte.js';
import AppConfigRidderrode from "../../AppConfigRidderrode.js";
import AppConfigDenIlp from "../../AppConfigDenIlp.js";
import AppConfigDevarana from "../../AppConfigDevarana.js";
import AppConfigSweetlake from "../../AppConfigSweetlake.js";

let aAlternateProductPrices = false; // niet veranderen

// Functie: update de prijs van een product op basis van ID
export function scenarioUpdateProductPriceByID(iProductID, iNewPriceCents)
{
  iProductID = parseInt(iProductID);
  const idx = products.lItems.findIndex((oItem) => oItem.iID === iProductID);

  if ( idx !== -1 )
  {
    products.lItems[idx].iPrice = iNewPriceCents;
  }

  booking_actions.handleBookingUpdated('scenarioUpdateProductPriceByID');
}

// Functie: pas prijzen aan op basis van een hardcoded matrix
export function scenarioUpdateProductPriceForTodayWithoutRemoteCheck(iBuyableID)
{
  const sEnvironmentID = progress.sEnvironmentID;
  const sArrivalDate = products.booking?.sArrivalDate; // format 31-03-2019
  const oArrivalDate = DateTimeUtil.getDateFromString(sArrivalDate);
  let bArrivalDateIsWeekend = false;

  if ( oArrivalDate && oArrivalDate.isFriSatSun() === true )
  {
    bArrivalDateIsWeekend = true;
  }

  if ( !aAlternateProductPrices )
  {
    // eenmalig de juiste config laden
    switch ( sEnvironmentID )
    {
      case ENVIRONMENT_RIDDERRODE:
        aAlternateProductPrices = AppConfigRidderrode.aAlternateProductPricesRidderrode;
        break;
      case ENVIRONMENT_DEN_ILP:
        aAlternateProductPrices = AppConfigDenIlp.aAlternateProductPricesDenIlp;
        break;
      case ENVIRONMENT_DEVARANA:
        aAlternateProductPrices = AppConfigDevarana.aAlternateProductPricesDevarana;
        break;
      case ENVIRONMENT_SWEETLAKE:
        aAlternateProductPrices = AppConfigSweetlake.aAlternateProductPricesSweetlake;
        break;
      default:
        aAlternateProductPrices = [];
    }
  }

  for ( const oAlternatePriceConfig of aAlternateProductPrices )
  {
    // checken of de prijs niet eerder veranderd is en nu teruggezet moet worden
    if ( oAlternatePriceConfig.hasOwnProperty("iOriginalPrice") )
    {
      products_update.scenarioUpdateProductPriceByID(oAlternatePriceConfig.iID, oAlternatePriceConfig.iOriginalPrice);
      delete oAlternatePriceConfig.iOriginalPrice;
    }

    for ( const oPriceRule of oAlternatePriceConfig.aRules )
    {
      if (
        oPriceRule.sDate === sArrivalDate ||
        (oPriceRule.sDate === "weekend" && bArrivalDateIsWeekend === true)
      )
      {
        const mProduct = products_select.getProductByID(oAlternatePriceConfig.iID);

        if ( mProduct )
        {
          if ( !oAlternatePriceConfig.hasOwnProperty("iOriginalPrice") )
          {
            oAlternatePriceConfig.iOriginalPrice = mProduct.iPrice;
          }

          products_update.scenarioUpdateProductPriceByID(oAlternatePriceConfig.iID, oPriceRule.iPrice);
        }
      }
    }
  }
}